<template>
  <van-form ref="form" :validate-first="true" :show-error-message="false">
    <van-field
      v-model="username"
      name="用户名"
      label="用户名"
      placeholder="请输入用户名"
      :rules="[{ required: true, message: '请填写用户名' }]"
    />
    <van-field
      v-model="password"
      type="password"
      name="密码"
      label="密码"
      placeholder="请输入密码"
      :rules="[{ required: true, message: '请填写密码' }]"
    />
    <div style="margin: 16px;">
      <van-button :disabled="loginBtn" :loading="loginBtn" round block type="info"  @click="handleSubmit">登陆</van-button>
    </div>
  </van-form>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import { ACCESS_TOKEN } from '@/store/variables'
import { Toast } from 'vant'
export default {
  data () {
    return {
      username: '',
      password: '',
      inputCode: '',
      randCodeImage: '',
      captchaKey: '',
      requestCodeSuccess: false,
      loginBtn: false
    }
  },
  created () {
    Vue.ls.remove(ACCESS_TOKEN)
    // this.handleChangeCheckCode()
  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    handleSubmit () {
      const that = this
      const loginParams = {}
      that.loginBtn = true
      that.$refs.form.validate().then(() => {
        loginParams.username = that.username
        loginParams.password = that.password
        console.log('登录参数', loginParams)
        that.Login(loginParams).then((res) => {
          if (res.success) {
            this.loginSuccess()
          } else {
            this.requestFailed(res)
          }
        }).catch((err) => {
          that.requestFailed(err)
        })
      }).catch(() => {
        console.log('验证失败')
      }).finally(() => {
        this.loginBtn = false
      })
    },
    loginSuccess () {
      this.$router.push({ name: 'home' })
    },
    requestFailed (err) {
      Toast.fail({
        message: ((err.response || {}).data || {}).message || err.msg || err.message || '请求出现错误，请稍后再试', duration: 2000
      })
    },
    handleChangeCheckCode () {
      this.$http.get('/sys/captcha?type=formula').then(res => {
        if (res.success) {
          this.randCodeImage = res.data.base64
          this.captchaKey = res.data.key
          this.requestCodeSuccess = true
        } else {
          this.$toast.fail(res.message)
          this.requestCodeSuccess = false
        }
      }).catch(() => {
        this.requestCodeSuccess = false
      })
    }
  }
}
</script>

<style lang="less" scoped>

  .user-layout-login {

  label {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  }

</style>
<style>
  .valid-error .ant-select-selection__placeholder{
    color: #f5222d;
  }
</style>
